"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTaskList = void 0;
const luxon_1 = require("luxon");
const hooks_1 = require("../../../hooks");
const useAnomalySearch_1 = require("../../../hooks/useAnomalySearch");
const contexts_1 = require("../../../contexts");
const DateManagement_1 = require("../../../utils/DateManagement");
const utils_1 = require("../../../features/Timecard/utils");
const usageLocation = 'TaskList';
const useGetTaskList = (featureGates, isTaskListEnabled) => {
    const { associateInfo } = (0, contexts_1.useTaaConfigsContext)();
    const { isLoading: isPayPeriodLoading, data: { pay_period_breakdown_info } = {} } = (0, hooks_1.usePayPeriod)({
        employeeId: associateInfo.employeeId,
        shouldFetch: isTaskListEnabled,
        usageLocation
    });
    const currStartDate = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.start_time;
    const currEndDate = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current.end_time;
    const prevStartDate = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.previous.start_time;
    const { isLoading: isPunchCorrStatusListLoading, data: { punchCorrections: punchCorrStatusList = [] } = {} } = (0, hooks_1.usePunchCorrStatusList)({
        enabled: featureGates.isPunchCorrStatusEnabled && isTaskListEnabled,
        employeeId: associateInfo.employeeId,
        timeRange: {
            start: luxon_1.DateTime.now().minus({ days: 6 }).startOf('day').toUTC().toISO(),
            end: luxon_1.DateTime.now().endOf('day').toUTC().toISO()
        },
        useV1Api: featureGates.isPunchCorrStatusV1Enabled,
        usageLocation
    });
    const { isLoading: isPunchesLoading, data: { punchesTimeSegments = [] } = {} } = (0, hooks_1.usePunches)({
        employeeId: associateInfo.employeeId,
        timeRange: {
            start: prevStartDate ? (0, DateManagement_1.getDateString)(prevStartDate) : undefined,
            end: currEndDate ? (0, DateManagement_1.getNextDateString)(currEndDate) : undefined
        },
        isEligibilityEnabled: featureGates.isDeleteDupePunchEnabled,
        usageLocation,
        temporalRouting: featureGates.isATPlusTemporalRoutingEnabled
    });
    const { isLoading: isPunchCorrectionsLoading, data: { punchCorrections = [] } = {} } = (0, hooks_1.usePunchCorrections)({
        employeeId: associateInfo.employeeId,
        timeRange: {
            start: currStartDate !== null && currStartDate !== void 0 ? currStartDate : '',
            end: currEndDate !== null && currEndDate !== void 0 ? currEndDate : ''
        },
        shouldFetch: featureGates.isPunchCorrectionEnabled &&
            !!(pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current) &&
            isTaskListEnabled,
        usageLocation
    });
    const { isLoading: isAnomalySearchLoading, data: { items: anomalySearchList = [] } = {} } = (0, hooks_1.useAnomalySearch)({
        employeeId: associateInfo.employeeId,
        startDate: prevStartDate
            ? (0, DateManagement_1.getDateString)(prevStartDate)
            : currStartDate
                ? (0, DateManagement_1.getDateString)(currStartDate)
                : undefined,
        endDate: currEndDate ? (0, DateManagement_1.getDateString)(currEndDate) : undefined,
        anomalyTypes: [useAnomalySearch_1.AnomalyTypes.MISSED_PUNCH, useAnomalySearch_1.AnomalyTypes.DUPLICATE_PUNCH],
        shouldFetch: !!featureGates.isAnomalySearchEnabled &&
            !!(pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current) &&
            !!isTaskListEnabled,
        usageLocation,
        deviationStatus: 'OPEN'
    });
    const taskListGroups = (0, utils_1.groupTaskList)(punchesTimeSegments, punchCorrStatusList, punchCorrections, pay_period_breakdown_info, anomalySearchList, featureGates.isAnomalySearchEnabled);
    return {
        isLoading: isPayPeriodLoading ||
            isPunchCorrStatusListLoading ||
            isPunchesLoading ||
            isPunchCorrectionsLoading ||
            isAnomalySearchLoading,
        taskListGroups,
        currentPayPeriod: pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current
    };
};
exports.useGetTaskList = useGetTaskList;
